var _desc, _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModulesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "streamline:module-three",
    rx: 7.5,
    width: 45,
    height: 45,
    transform: "translate(0.500000 0.500000)",
    fill: "#F7F8F8",
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.71 25.14C12.48 25.14 12.26 25.23 12.1 25.39C11.94 25.55 11.85 25.77 11.85 26L11.85 33.28C11.85 33.51 11.94 33.73 12.1 33.89C12.26 34.05 12.48 34.14 12.71 34.14L20 34.14C20.22 34.14 20.44 34.05 20.6 33.89C20.76 33.73 20.85 33.51 20.85 33.28L20.85 26C20.85 25.77 20.76 25.55 20.6 25.39C20.44 25.23 20.22 25.14 20 25.14L12.71 25.14ZM26 25.14C25.77 25.14 25.55 25.23 25.39 25.39C25.23 25.55 25.14 25.77 25.14 26L25.14 33.28C25.14 33.51 25.23 33.73 25.39 33.89C25.55 34.05 25.77 34.14 26 34.14L33.28 34.14C33.51 34.14 33.73 34.05 33.89 33.89C34.05 33.73 34.14 33.51 34.14 33.28L34.14 26C34.14 25.77 34.05 25.55 33.89 25.39C33.73 25.23 33.51 25.14 33.28 25.14L26 25.14ZM19.36 11.85C19.13 11.85 18.92 11.94 18.75 12.1C18.59 12.26 18.5 12.48 18.5 12.71L18.5 20C18.5 20.22 18.59 20.44 18.75 20.6C18.92 20.76 19.13 20.85 19.36 20.85L26.65 20.85C26.87 20.85 27.09 20.76 27.25 20.6C27.41 20.44 27.5 20.22 27.5 20L27.5 12.71C27.5 12.48 27.41 12.26 27.25 12.1C27.09 11.94 26.87 11.85 26.65 11.85L19.36 11.85Z",
    stroke: "#7252DC",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModulesIcon);
export default __webpack_public_path__ + "static/media/modulesIcon.d5a934d087994f99300b7ab0e099e61d.svg";
export { ForwardRef as ReactComponent };